<template>
  <div class="suborg-list-page">
    <div v-if="pagedSubOrgs.length > 0" class="suborg-list">
      <div
        class="suborg-row"
        v-for="(subOrg, index) in pagedSubOrgs"
        :key="rowKey(subOrg, index)">
        <div class="suborg-row-main" @click="toggleExpand(subOrg, index)">
          <div
            class="suborg-avatar"
            :class="{ 'has-logo': subOrgLogo(subOrg) }"
            :style="subOrgLogo(subOrg) ? null : { background: avatarColor(index) }">
            <img v-if="subOrgLogo(subOrg)" :src="subOrgLogo(subOrg)" :alt="subOrg.title || ''">
            <span v-else>{{ initials(subOrg.title) }}</span>
          </div>
          <div class="suborg-title-block">
            <div class="suborg-title">{{ subOrg.title }}</div>
            <div class="suborg-contact">
              <span class="icon-user meta-icon" aria-hidden="true"></span>
              <span>{{ contactLabel(subOrg) }}</span>
            </div>
          </div>
          <button type="button" class="expand-btn" @click.stop="toggleExpand(subOrg, index)">
            <span class="fa" :class="isExpanded(subOrg, index) ? 'fa-angle-up' : 'fa-angle-down'"></span>
          </button>
        </div>
        <div class="suborg-row-details" v-if="isExpanded(subOrg, index)">
          <div class="meta-item">
            <span class="ic2_url meta-icon" aria-hidden="true"></span>
            <a v-if="website(subOrg)" :href="website(subOrg)" target="_blank">{{ $t('website') }}</a>
            <span v-else>{{ $t('na') }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-mail meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.email) }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-location meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.city) }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-map meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.state) }}</span>
          </div>
          <div class="meta-item">
            <span class="ico-map meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.country) }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-phone meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.phone) }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-phone meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.fax) }}</span>
          </div>
          <div class="meta-item">
            <span class="icon-location meta-icon" aria-hidden="true"></span>
            <span>{{ displayValue(subOrg.address) }}</span>
          </div>
          <div class="meta-section">
            <div class="meta-heading">
              <span class="ic2_description meta-icon" aria-hidden="true"></span>
              <span>{{ $t('description') }}</span>
            </div>
            <div v-if="subOrg.description" v-html="subOrg.description"></div>
            <div v-else>{{ $t('noDescriptionForSchool', { label: getSubOrgLabel }) }}</div>
          </div>
          <div class="meta-section" v-if="subOrg.mission">
            <div class="meta-heading">{{ $t('mission') }}</div>
            <div v-html="subOrg.mission"></div>
          </div>
          <div class="meta-item" v-if="subOrg.youtubeUri">
            <a :href="subOrg.youtubeUri" target="_blank">{{ $t('youtube') }}</a>
          </div>
          <div class="meta-item" v-if="subOrg.facebookUri">
            <a :href="subOrg.facebookUri" target="_blank">{{ $t('facebook') }}</a>
          </div>
          <div class="meta-item" v-if="subOrg.linkedinUri">
            <a :href="subOrg.linkedinUri" target="_blank">{{ $t('linkedin') }}</a>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no_result">{{ $t('noResult') }}</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import employerSettingsFlags from '../employerSettingsFlags'

export default {
  name: 'subOrgList',
  mixins: [employerSettingsFlags],
  props: {
    parentId: {
      type: String,
      default: ''
    },
    search: {
      type: String,
      default: ''
    },
    page: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      subOrgs: [],
      expandedKey: null,
      avatarColors: ['#e08a4a', '#3d5a99', '#9b8ac4', '#4a7c8c']
    }
  },
  mounted () {
    this.loadSubOrgs()
  },
  methods: {
    ...mapActions([
      'loadSubOrganizationsByParent'
    ]),
    loadSubOrgs () {
      if (!this.parentId) {
        this.subOrgs = []
        this.expandedKey = null
        this.emitPaging()
        return
      }
      this.loadSubOrganizationsByParent(this.parentId).then((res) => {
        this.subOrgs = this.normalizeList(res)
        this.expandedKey = null
        this.emitPaging()
      })
    },
    normalizeList (res) {
      if (!res) {
        return []
      }
      if (Array.isArray(res)) {
        return res
      }
      if (Array.isArray(res.data)) {
        return res.data
      }
      if (Array.isArray(res.subOrganizations)) {
        return res.subOrganizations
      }
      return []
    },
    rowKey (subOrg, index) {
      if (!subOrg) {
        return index
      }
      return subOrg.uuid || subOrg.id || index
    },
    isExpanded (subOrg, index) {
      return this.expandedKey === this.rowKey(subOrg, index)
    },
    toggleExpand (subOrg, index) {
      let key = this.rowKey(subOrg, index)
      this.expandedKey = this.expandedKey === key ? null : key
    },
    subOrgLogo (subOrg) {
      return (subOrg && subOrg.logo) || ''
    },
    website (subOrg) {
      return (subOrg && (subOrg.website || subOrg.uri)) || ''
    },
    contactLabel (subOrg) {
      let title = (subOrg && (subOrg.contanctTitle || subOrg.contactTitle)) || ''
      let name = (subOrg && (subOrg.contanctName || subOrg.contactName)) || ''
      if (title && name) {
        return title + ': ' + name
      }
      if (title || name) {
        return title || name
      }
      return this.$t('na')
    },
    displayValue (value) {
      return value || this.$t('na')
    },
    initials (title) {
      if (!title) {
        return ''
      }
      let first = title.trim().split(/\s+/)[0]
      if (first.length <= 4) {
        return first.toUpperCase()
      }
      return first.substring(0, 3).toUpperCase()
    },
    avatarColor (index) {
      return this.avatarColors[index % this.avatarColors.length]
    },
    matchesSearch (subOrg, term) {
      if (!term) {
        return true
      }
      let values = [
        subOrg.title,
        subOrg.city,
        subOrg.state,
        subOrg.country,
        subOrg.address,
        subOrg.email,
        subOrg.contanctName,
        subOrg.contactName,
        subOrg.contanctTitle,
        subOrg.contactTitle
      ]
      return values.some((value) => {
        return (value || '').toLowerCase().indexOf(term) !== -1
      })
    },
    emitPaging () {
      let total = this.filteredSubOrgs.length
      let totalPages = Math.ceil(total / this.pageSize)
      if (totalPages < 1) {
        totalPages = 1
      }
      this.$emit('paging', {
        total: total,
        firstPage: this.page <= 0,
        lastPage: this.page >= totalPages - 1
      })
    }
  },
  computed: {
    filteredSubOrgs () {
      let list = this.subOrgs || []
      let term = (this.search || '').toLowerCase()
      if (!term) {
        return list
      }
      return list.filter((subOrg) => {
        return this.matchesSearch(subOrg, term)
      })
    },
    pagedSubOrgs () {
      let start = this.page * this.pageSize
      return this.filteredSubOrgs.slice(start, start + this.pageSize)
    }
  },
  watch: {
    parentId () {
      this.loadSubOrgs()
    },
    search () {
      this.expandedKey = null
      this.emitPaging()
    },
    page () {
      this.expandedKey = null
      this.emitPaging()
    },
    pageSize () {
      this.expandedKey = null
      this.emitPaging()
    },
    filteredSubOrgs () {
      this.emitPaging()
    }
  }
}
</script>

<style scoped>
  .suborg-row {
    border-bottom: 1px solid #e6e6e6;
    background: #fff;
  }
  .suborg-row-main {
    display: flex;
    align-items: center;
    padding: 12px 4px;
  }
  .suborg-avatar {
    width: 56px;
    height: 28px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    color: #000;
    font-weight: 600;
    overflow: hidden;
    flex-shrink: 0;
  }
  .suborg-avatar.has-logo {
    background: transparent;
  }
  .suborg-avatar img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .suborg-title-block {
    flex: 1;
    min-width: 0;
  }
  .suborg-title {
    font-weight: 500;
    color: #4a4a4a;
  }
  .suborg-contact {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #6b6b6b;
  }
  .expand-btn {
    border: none;
    background: transparent;
    font-size: 18px;
  }
  .suborg-row-details {
    padding: 0 8px 12px 66px;
    font-size: 13px;
    color: #4a4a4a;
  }
  .meta-item,
  .meta-heading {
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    word-break: break-word;
  }
  .meta-icon {
    margin-right: 8px;
    flex-shrink: 0;
    font-size: 16px;
    color: #4a4a4a;
    line-height: 1;
  }
  .meta-section {
    margin-top: 10px;
  }
  .meta-heading {
    font-weight: 600;
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/app/employer/components/SubOrgList.vue